import { init_scroll_tracking } from './common/tracking.helpers.js';

const dataLayer = window.dataLayer || [];
const data = window.data || [];
//https://bitbucket.org/adviso/generic-sis-lassonde/

//USC001
dataLayer.push({
  event: 'PV',
  page: {
    content_group: data.content_group,
    page_language: data.language,
    page_title: document.title,
  },
  user: {
    user_industry: null, // Si non disponible, utiliser la valeur null.
    user_region: null, // Si non disponible, utiliser la valeur null.
  },
});

//click events
document.addEventListener('click', function (event) {
  //5.6 UCS006 - Lassonde - Clic vers les réseaux sociaux
  const socialMedia = event.target.closest('.social-media-button');
  if (socialMedia) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        interaction_location: 'footer',
        click_type: 'social media click',
        link_text: socialMedia.title,
        link_url: socialMedia.href,
        social_media_name: socialMedia.querySelector('.sr-only').textContent, // Modifier en fonction du réseau social en question.
      },
    });
  }

  const socialMediaFooter = event.target.closest(
    '.instagram-section .social-media-button'
  );
  if (socialMediaFooter) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        interaction_location: 'footer',
        click_type: 'social media click',
        link_text: socialMediaFooter.title,
        link_url: socialMediaFooter.href,
        social_media_name:
          socialMediaFooter.querySelector('.sr-only').textContent, // Modifier en fonction du réseau social en question.
      },
    });
  }

  const socialMediaAtSunrype = event.target.closest(
    '.social-media-button-footer'
  );
  if (socialMediaAtSunrype) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        interaction_location: 'footer',
        click_type: 'social media click',
        link_text: socialMediaAtSunrype.title,
        link_url: socialMediaAtSunrype.href,
        social_media_name: socialMediaAtSunrype.textContent, // Modifier en fonction du réseau social en question.
      },
    });
  }

  const instagramFeedLink = event.target.closest('.sbi_photo');
  if (instagramFeedLink) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        interaction_location: 'footer',
        click_type: 'social media click',
        link_text:
          instagramFeedLink.querySelector('.sbi-screenreader').textContent,
        link_url: instagramFeedLink.href,
        social_media_name: 'Instagram',
      },
    });
  }

  const socialMediaAtKiju = event.target.closest(
    '.footer-socials__instagram-handle'
  );
  if (socialMediaAtKiju) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        interaction_location: 'footer',
        click_type: 'social media click',
        link_text: socialMediaAtKiju.title,
        link_url: socialMediaAtKiju.href,
        social_media_name: 'Instagram',
      },
    });
  }

  //5.7 UCS007 - Lassonde - Clic vers un partenaire commercial
  const productSupplier = event.target.closest('.product-supplier');
  if (productSupplier) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'commercial link',
        link_url: productSupplier.href,
      },
    });
  }

  //5.8 UCS008 - Lassonde - Clic sur un produit
  const link = event.target.closest('.listing__item');
  if (link) {
    const url = link.href;
    const productLinkRegex =
      '\\/our-products\\/.*\\/.*\\/|\\/fr\\/nos-produits\\/.*\\/.*\\/';
    const isProduct = url.match(productLinkRegex);
    if (isProduct) {
      const link_text = link.querySelector('.sr-only').textContent;

      dataLayer.push({
        event: 'userAction',
        interaction: {
          event_name: 'click',
          click_type: 'product click',
          link_text: link_text.trim(),
          link_url: url,
        },
        product: {
          product_category: link.dataset.productCategory,
          product_name: link.dataset.productName,
          product_format: link.dataset.productSize,
        },
      });
    }
  }

  //5.9 UCS009 - Lassonde - Clic sur un CTA
  const ctaBtn = event.target.closest('.ctaBtn, .suppliers-popup-btn');
  if (ctaBtn) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'button click',
        link_text: ctaBtn.textContent.trim(), // Voir le tableau 'CTA Buttons' pour la sélection des boutons à intégrer dans ce Use Case.
        link_url: ctaBtn.href,
      },
    });
  }

  const ctaBLogBtn = event.target.closest('.blog-cta-tracking');
  if (ctaBLogBtn) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'button click',
        link_text: ctaBLogBtn.textContent.trim(), // Voir le tableau 'CTA Buttons' pour la sélection des boutons à intégrer dans ce Use Case.
        link_url: ctaBLogBtn.href,
      },
    });
  }

  // Only for Gutenberg button block

  const ctaBtnTrackingClass = event.target.closest('.cta-tracking');
  if (ctaBtnTrackingClass) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'button click',
        link_text: ctaBtnTrackingClass.textContent.trim(), // Voir le tableau 'CTA Buttons' pour la sélection des boutons à intégrer dans ce Use Case.
        link_url: ctaBtnTrackingClass.querySelector('a').href,
      },
    });
  }

  //5.10 UCS010 - Lassonde - Lecture d'une vidéo
  //pour le moment toujours dans GTM, vu la complexité de mise en oeuvre

  //5.15 UCS015 - Lassonde - Clic sur une recommandation de lecture
  const relatedContent = event.target.closest('.relatedPost');

  if (relatedContent) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'content recommendation',
        link_url: relatedContent.href,
      },
    });
  }

  //Clic d'un lien de menu
  const menuLink = event.target.closest('.nav-item__link');
  if (menuLink) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'button click',
        link_text: menuLink.textContent.trim(), // Voir le tableau 'CTA Buttons' pour la sélection des boutons à intégrer dans ce Use Case.
        link_url: menuLink.href,
      },
    });
  }

  //5.18 UCS018 - Lassonde - Clic vers le site Carriere
  const carreerLink = event.target.closest(
    '.footer-menu-4__subnav__0 .nav-item__link, .menu-footer-4__subnav__0 .nav-item__link'
  );
  if (carreerLink) {
    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'click',
        click_type: 'career link',
        interaction_location: 'footer',
        link_url: carreerLink.href,
      },
    });
  }
});

//5.12 UCS012 - Lassonde - Lecture d'un article
if (window.location.href.match('/blogue/.*/|/blog/.*/')) {
  init_scroll_tracking([25, 50, 75, 100], function (step) {
    const reading_time_string = document
      .querySelector('.dl-reading-time')
      .textContent.trim();
    let reading_time = null;
    if (reading_time_string) {
      reading_time = reading_time_string.substr(
        0,
        reading_time_string.indexOf(' ')
      );
    }

    dataLayer.push({
      event: 'userAction',
      interaction: {
        event_name: 'scroll',
        scroll_progress: step + '%',
        reading_time: reading_time,
      },
    });
  });
}
